var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDeletebox2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.624 4.092v-2h10v2h5v2h-2v15a1 1 0 0 1-1 1h-14a1 1 0 0 1-1-1v-15h-2v-2h5zm-1 2v14h12v-14h-12zm3 3h2v8h-2v-8zm4 0h2v8h-2v-8z",
    fill: "#A7A9AC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDeletebox2);
export default __webpack_public_path__ + "static/media/ic-deletebox2.7b198d7dacaafa0ffe276c040167d76c.svg";
export { ForwardRef as ReactComponent };